import isFunction from 'lodash/isFunction';
import get from 'lodash/get';

import xmlHttpRequestWrapper from './wrapper';

const xmlHttpRequest = async ({
    method,
    host,
    body,
    headers,
    onUploadProgress
}) => {
    const onUploadProgressCB = progressEvent => {
        const { loaded, total } = progressEvent;
        isFunction(onUploadProgress) && onUploadProgress({ loaded, total });
    };
    return xmlHttpRequestWrapper({
        method,
        url: host,
        data: body,
        headers: {
            'Content-Type': get(headers, 'Content-Type', 'application/json')
        },
        onUploadProgress: isFunction(onUploadProgress) ? onUploadProgressCB : undefined
    }).then(response => response
    ).catch(error => {
        throw new Error(error);
    })
};
export default xmlHttpRequest;
